module.exports = __webpack_public_path__ + "img/edit.8b71d226.svg";